import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

const trHeight = '6rem';

export const TableWrapper = styled.section`
  overflow-y: auto;
  max-height: 80%;
  width: 100%;
  grid-column: 1 / -1;

  @media (max-width: ${breakpoints.medium}) {
    overflow-x: scroll;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  height: ${trHeight};
  border-radius: 3px 3px 0 0;
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};

  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;

  th {
    text-align: center;
    padding-left: 4rem;
    padding-left: var(--th-padding-left, 40px);
    text-align: start;

    @media (max-width: ${breakpoints.medium}) {
      min-width: 100px;
    }
  }
`;

export const TableBody = styled.tbody`
  > tr {
    height: ${trHeight};
    border-bottom: 1px solid #dcdcdc;
    transition: background 0.2s;

    &:hover {
      cursor: pointer;
      background: #ffef8e;
      transition: background 0.2s;
    }
  }

  td {
    text-align: start;
    white-space: pre-wrap;
    padding-left: var(--td-padding-left, 40px);
  }
`;

export const TableNoItems = styled.h2`
  text-align: center;
  font-weight: 400;
  margin-top: 6.4rem;
  opacity: 0.5;
`;
